package oldframes.files

import bootstrap.*
import ru.it_mozaika.utils.checkResponseError
import oldcomponents.NotyType
import oldcomponents.showNotification
import io.ktor.client.call.*
import io.ktor.client.plugins.*
import io.ktor.client.request.forms.*
import io.ktor.http.*
import io.ktor.utils.io.core.*
import io.ktor.utils.io.js.*
import kotlinx.css.*
import kotlinx.html.InputType
import kotlinx.html.js.*
import ru.it_mozaika.sender.common.models.File
import ru.it_mozaika.sender.common.models.availableExtensions
import org.khronos.webgl.ArrayBuffer
import org.w3c.dom.DragEvent
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileList
import org.w3c.files.FileReader
import org.w3c.files.get
import react.*
import react.dom.*
import ru.it_mozaika.sender.js.application.Http
import styled.*

external interface UploadFileDialogProps : Props {
    var store: String
    var isOpen: Boolean
    var onClose: (Boolean) -> Unit
}
val uploadFileDialog = fc<UploadFileDialogProps> { props ->

    var files by useState(listOf<File>())
    val filesRef = useRef(files)
    var fileUploadProgress by useState(-1)

    Modal {
        attrs.show = props.isOpen
        attrs.size = "lg"
        attrs.onHide = { props.onClose(false) }
        attrs.backdrop = fileUploadProgress == -1
        ModalHeader {
            ModalTitle {
                +"Выберите файл для загрузки"
            }
        }
        ModalBody {
            Table {
                attrs.bordered = true
                attrs.hover = true
                tbody {
                    files.forEach { file ->
                        tr {
                            td { +file.originalName }
                            td { +file.size.toString() }
                            td {
                                iconButton {
                                    attrs.icon = "la la-trash"
                                    attrs.disabled = false
                                    attrs.type = IconButtonType.Danger
                                    attrs.onClickFunction = {
                                        Http.delete("/files/${file.fileName}") { response ->
                                            response.checkResponseError()?.let {
                                                showNotification("Ошибка удаления файла", NotyType.Error)
                                                return@delete
                                            }
                                            files = (filesRef.current ?: files).minus(file)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            uploadFileDnd {
                attrs.store = props.store
                attrs.isShow = fileUploadProgress == -1
                attrs.onUploadProgress = { fileUploadProgress = -1 }
                attrs.onUpload = {
                    fileUploadProgress = -1
                    files = (filesRef.current ?: files).plus(it)
                }
            }
        }
        ModalFooter {
            Button {
                attrs.variant = "secondary"
                attrs.disabled = fileUploadProgress in 0..99
                attrs.onClick = {
                    props.onClose(files.isNotEmpty())
                }
                +"Закрыть"
            }
//            Button {
//                attrs.variant = "gradient-01"
//                attrs.onClick = {
//
//                }
//                +"Загрузить"
//            }
        }
    }
}

fun uploadFileToServer(store: String, file: org.w3c.files.File, buffer: ArrayBuffer, progress: (Int) -> Unit, callback: (List<File>) -> Unit) {
    Http.put(
        "/files",
        MultiPartFormDataContent(
            formData {
                appendInput("file", Headers.build {
                    append(
                        HttpHeaders.ContentDisposition,
                        "filename=${file.name}")
                }, file.size.toLong()) {
                    buildPacket { writeFully(buffer) }
                }
                append("store", store)
            }
        ),
        {
            onUpload { bytesSentTotal, contentLength ->
                progress((bytesSentTotal * 100L / contentLength).toInt())
            }
        }
    ) { response ->
        when (response.status) {
            HttpStatusCode.OK -> callback(response.body())
            else -> showNotification("Ошибка ${response.status}", NotyType.Warning)
        }
    }
}

external interface UploadFileDndProps : Props {
    var isShow: Boolean
    var store: String
    var onUpload: (List<File>) -> Unit
    var onUploadProgress: (Int) -> Unit
}
val uploadFileDnd = fc<UploadFileDndProps> { props ->

    var isOver by useState(false)
    val fileInputRef = useRef<HTMLInputElement>()
    var fileUploadProgress by useState(-1)

    useEffect(fileUploadProgress) {
        props.onUploadProgress(fileUploadProgress)
    }

    fun uploadFiles(fileList: FileList) {
        if (fileList.length > 0) {
            val resultFiles = (0 until fileList.length).mapNotNull { i ->
                fileList[i]?.let { file ->
                    if (file.name.contains(".")) {
                        val ext = file.name.substringAfterLast(".").lowercase()
                        if (availableExtensions.contains(ext)) {
                            file
                        } else {
                            null
                        }
                    } else {
                        null
                    }
                }
            }
            if (resultFiles.isNotEmpty()) {
                val uploadResult = mutableListOf<File>()
                resultFiles.subList(0, 1).forEach { inputFile ->  // TODO: add normal multi file support
                    fileUploadProgress = 0
                    val reader = FileReader()
                    reader.readAsArrayBuffer(inputFile)
                    reader.onload = { _ ->
                        val buffer = reader.result as ArrayBuffer
                        uploadFileToServer(props.store, inputFile, buffer, { p -> fileUploadProgress = p }) { result ->
                            uploadResult += result
                            if (uploadResult.size == resultFiles.size) {
                                props.onUpload(uploadResult)
                            }
                        }
                    }
                }
            }
        }
    }

    styledForm {
        css.display = Display.none
        styledInput(InputType.file) {
            css.display = Display.none
            ref = fileInputRef
            attrs.onChangeFunction = {
                (it.target as? HTMLInputElement)?.let { input ->
                    input.files?.let { fl -> uploadFiles(fl) }
                    input.value = ""
                }
            }
        }
    }

    styledDiv {
        attrs.onClickFunction = {
            if (fileUploadProgress < 0) {
                fileInputRef.current?.click()
            }
        }
        attrs.onDragOverFunction = {
            if (!isOver) {
                isOver = true
            }
            it.preventDefault()
            it.stopPropagation()
        }
        attrs.onDragLeaveFunction = {
            isOver = false
            it.preventDefault()
            it.stopPropagation()
        }
        attrs.onDropFunction = {
            val e = it.asDynamic().nativeEvent as DragEvent
            e.dataTransfer?.let { dataTransfer ->
                uploadFiles(dataTransfer.files)
            }
            isOver = false
            it.preventDefault()
            it.stopPropagation()
        }
        attrs.jsStyle {
            backgroundColor = if (isOver) "#17a2b8" else "#a3dcec"
            border = "2px dashed ${if (isOver) "#5d5386" else "#17a2b8"}"
            display = if (props.isShow) "block" else "none"
        }
        css {
            width = 100.pct
            margin(4.px)
            minHeight = 200.px
        }
        div("row d-flex justify-content-center") {
            styledI {
                attrs.jsStyle {
                    color = if (isOver) "#5d5386" else "#17a2b8"
                }
                css {
                    classes.add("la la-cloud-upload")
                    fontSize = 4.rem
                    padding(5.px)
                    marginTop = 32.px
                }
            }
        }
        div("row d-flex justify-content-center") {
            styledLabel {
                attrs.jsStyle {
                    color = if (isOver) "#5d5386" else "#17a2b8"
                }
                css {
                    fontSize = 1.75.rem
                }
                +"Нажмите или переместите файлы сюда"
            }
        }
    }
}